import { createUserManager } from "redux-oidc";
import { Log, User, UserManagerSettings } from "oidc-client";
import { getUrl } from 'features/shared/helpers/urlHelper'
import { getDynamicConfig } from "infrastructure/configuration/configurationHelper";
import i18n from "infrastructure/localization/i18n";

const dynamicConfig = getDynamicConfig();

// logging
if (dynamicConfig.enableDebugLogging) {
  Log.logger = console;
  Log.level = Log.DEBUG;   
}

// auth configuration
const userManagerConfig: UserManagerSettings = {
  client_id: dynamicConfig.identityServerClientId,
  authority: dynamicConfig.identityServerUrl,
  response_type: "code",
  scope: `openid profile roles email address ${dynamicConfig.identityServerFlexiApiName}`,
  redirect_uri: getUrl("callback"),
  silent_redirect_uri: getUrl("silent_renew"),
  automaticSilentRenew: true,
  filterProtocolClaims: true,
  loadUserInfo: true,
  // extraQueryParams: {
  //   ui_locales: 'en-US' // lanaguage from local storage
  // }
};

const UserManager = createUserManager(userManagerConfig);

// register event handlers
UserManager.events.addSilentRenewError((error: any) => {
  // pokud IS4 nemá validní SSL/TLS certifikát silentRenew nefunguje a vyhazuje login_required
  // pokud error nastane, tak je uživatel přesměrován na IS4 pro přihlášení
  // pokud je na IS4 nastavno SSO, tak je uživatel automaticky přihlášen a přesměrován zpět
  if (error.hasOwnProperty("error") && error["error"] === "login_required") {
    UserManager.signinRedirect();
  }
})

UserManager.events.addUserSignedOut (() => {
  // ve FIREFOXU (od verze X) nefunguje automaticke odhlaseni kvuli omezeni pristupu ke cookies z cizi domeny (cross-site)
  // error zpusobuje: https://developer.mozilla.org/en-US/docs/Web/Privacy/Storage_Access_Policy/Errors/CookiePartitionedForeign
  // Pro ostatni prohlizece by melo fungovat diky: https://www.thinktecture.com/en/identityserver/prepare-your-identityserver/
  if(!(navigator.userAgent.toLowerCase().indexOf('firefox') > -1)){
    UserManager.signoutRedirect();
  }  
});

UserManager.events.addUserLoaded ((user: User) => {
  // set language sended from identity provider (IdentityServer)
  if (user?.profile?.locale) {
    i18n.changeLanguage(user.profile.locale); 
   }
});

export default UserManager;